import React, { Suspense, lazy } from 'react';
import Loader from 'components/Elements/Loader/Loader';
import { AuthRoutes } from 'features/auth';

const SclaLanding = lazy(() => import('features/scla-landing/SclaLanding'));
const PublicSignForm = lazy(() => import('features/signed-forms/routes/PublicSignForm'));
const SclaOrientationFormsList = lazy(
  () => import('features/scla-orientation-forms-public/routes/SclaOrientationFormsList'),
);

const publicRoutes = [
  {
    // Signed-out visitors see the SCLA landing page; deeper SCLA paths still
    // go to sign-in and come back after.
    path: '/scla-application',
    element: (
      <Suspense fallback={<Loader theme="dark" isVisible fullscreen />}>
        <SclaLanding />
      </Suspense>
    ),
  },
  {
    path: '/scla-orientation-forms',
    element: (
      <Suspense fallback={<Loader theme="dark" isVisible fullscreen />}>
        <SclaOrientationFormsList />
      </Suspense>
    ),
  },
  {
    path: '/sign/:token',
    element: (
      <Suspense fallback={<Loader theme="dark" isVisible fullscreen />}>
        <PublicSignForm />
      </Suspense>
    ),
  },
  {
    path: '/*',
    element: (
      <Suspense fallback={<Loader theme="dark" isVisible fullscreen />}>
        <AuthRoutes />
      </Suspense>
    ),
  },
];

export default publicRoutes;
